<!--
 * @Author: scg
 * @Date: 2022-01-17 16:18:42
 * @LastEditTime: 2022-03-03 18:33:48
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="page_title">{{ list[msg].title }}</div>
    <div class="Disable">
      <div class="Disable_ul">
        <div
          v-html="
            val.content +
            `<text style='color: red;font-weight: bolder;font-size: 16px;'>${
              val.device_code || ''
            }</text>`
          "
          class="Disable_li end"
          v-for="(val, key) in list"
          :key="key"
          v-if="msg == key"
        ></div>
      </div>
      <video v-if="video_url" :src="video_url" class="Disable_img"></video>
      <!-- <img src="https://p.ssl.qhimg.com/t017efc9aa407b6bb9f.png" alt="" class="Disable_img"> -->
    </div>
    <div class="twoButton">
      <div @click="back" class="BackButton">{{$t('disable.back')}}</div>
      <div @click="next()" class="loginButton">{{$t('disable.continue')}}</div>
    </div>
  </div>
</template>

<script>
import { binddeviceGetStepDes, getEquipmentDetail, BindDeviceGetDeviceList, BindDeviceGetSystemList } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      key: {
        device_brand: 1,
        system: 1,
        //  device_brand: this.$route.params.id ? this.$route.params.id : this.get_device_brand(),
        // system: this.$route.params.id ? this.$route.params.id : this.get_system(),
        equipment_id: localStorage.getItem('systemId')
      },
      video_url: '',
      list: [],
      msg: 0
    }
  },
  mounted () {
    binddeviceGetStepDes(this.key).then((adj) => {
      console.log(adj)
      this.list = adj.data.step
      this.video_url = this.list[this.msg].video_url
    })
  },
  methods: {
    get_system () {
      BindDeviceGetSystemList().then((adj) => {
        console.log(adj.data)
        this.list = adj.data[0].id
      })
    },
    get_device_brand () {
      BindDeviceGetDeviceList().then((adj) => {
        // console.log(adj.data, 9999)
        return adj.data[0].id
      })
    },
    back () {
      if (this.msg <= 0) {
        this.$router.go(-1)
      } else {
        this.msg--
      }
    },
    next () {
      this.msg++
      if (this.msg + 1 > this.list.length) {
        getEquipmentDetail(this.key).then((res) => {
          if (res.code !== 1) {
            this.$message(res.msg)
            return
          }
          if (res.data.status !== 1) {
            this.$message(this.$t('disable.tips'))
            return
          }
          this.$router.push({ name: 'And' })
        })
        //
      } else {
        this.video_url = this.list[this.msg].video_url
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  background: #fff;
  overflow: hidden;
}
.Disable {
  margin-left: 5%;
  width: 85%;
  max-width: 800px;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  overflow: hidden;
  padding: 30px 0;
}
.Disable_img {
  float: left;
  width: 240px;
  margin-left: 40px;
}
.Disable_ul {
  float: left;
  margin-left: 30px;
}
.Disable_li {
  /* width: 400px; */
  /* padding-left: 30px; */
  position: relative;
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 20px;
  min-height: 40px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAABCAYAAADn9T9+AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhBOTMyM0MyRUM5MTExRUJCMkZDRTA4NEIxNUYzNTU4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhBOTMyM0MzRUM5MTExRUJCMkZDRTA4NEIxNUYzNTU4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OEE5MzIzQzBFQzkxMTFFQkIyRkNFMDg0QjE1RjM1NTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OEE5MzIzQzFFQzkxMTFFQkIyRkNFMDg0QjE1RjM1NTgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7uY2GkAAAAGUlEQVR42mL8//8/Ay7A+P4IiEoDEQABBgCI1AUZISeM0QAAAABJRU5ErkJggg==)
    0 repeat-y;
}
.Disable_li.end {
  background: none;
}
.Disable_li div.one {
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #99f8e7;
  line-height: 18px;
  font-size: 12px;
  color: #000927;
  text-align: center;
  left: 0;
  top: 0;
}
.Disable_li div * {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Disable.vue